import * as S from "./CheckListItemStyles";
import type {
  ChecklistItemConfig,
  InputDescription,
  IntegrationDescription,
} from "@smartsuite/automation-engine-api";
import { toJS } from "mobx";
import type {
  ActionCandidate,
  InputCandidate,
  TriggerCandidate,
} from "../../../../../../../../../types/candidate";
import { DateEditor, DateTab } from "../../DateEditor";
import { MemberEditor, MemberTab } from "../../../../../MemberEditor";
import type { ChecklistItemConfigCandidate } from "../../../../../../../../../types/checklist";
import { SmartDocEditor } from "../../SmartDocEditor";
import { t } from "i18next";

export const CheckListItem: React.FC<{
  onChange: (value: ChecklistItemConfigCandidate) => void;
  integrations: IntegrationDescription[];
  value?: ChecklistItemConfig;
  input: InputCandidate;
  trigger: TriggerCandidate;
  actions: ActionCandidate[];
  action?: ActionCandidate | undefined;
  showValidationError: boolean;
  description?: InputDescription;
  hash: string;
}> = ({
  onChange,
  integrations,
  value,
  input,
  trigger,
  actions,
  action,
  showValidationError,
  description,
  hash,
}) => {
  const triggerFieldsToHide = [
    "context-output-current-user",
    "field-followed_by",
  ];
  return (
    <S.CheckListItemWrapper>
      <S.CheckListItemTop>
        <SmartDocEditor
          input={toJS({
            ...input,
            inputId: hash,
            value: value?.text,
          })}
          onChange={(input: InputCandidate) => {
            onChange({
              text: input.value,
              hash,
            });
          }}
          trigger={trigger}
          actions={actions}
          integrations={integrations}
          placeholder={t("automation-form.add-new-item")}
          showValidationError={showValidationError}
          description={{
            label: "Item Description",
            icon: "",
            inputId: description?.inputId ?? "",
            subLabel: "",
            dynamic: false,
            editor: {
              ...(description?.editor ?? {
                editor: {
                  oneofKind: "smartdoc",
                  smartdoc: {},
                },
                validation: {
                  oneofKind: undefined,
                },
              }),
              required: true,
            },
          }}
        />
      </S.CheckListItemTop>
      <S.CheckListItemBottom>
        <S.CheckListItemFieldWrapper>
          <DateEditor
            input={toJS({
              ...input,
              value: value?.timeStamp,
            })}
            onChange={(input: InputCandidate) => {
              onChange({
                timeStamp: input.value,
                hash,
              });
            }}
            trigger={trigger}
            actions={actions}
            action={action}
            integrations={integrations}
            description={{
              ...description,
              label: "Due Date",
              icon: "",
              inputId: description?.inputId ?? "",
              subLabel: description?.subLabel ?? "",
              dynamic: description?.dynamic ?? false,
            }}
            defaultTab={DateTab.root}
            filterSystemFields={(item) => !item.value.includes("-")}
            useDateWithTime={true}
            isNested
          />
        </S.CheckListItemFieldWrapper>
        <S.CheckListItemFieldWrapper>
          <MemberEditor
            config={{
              ...input,
              value: value?.member,
            }}
            trigger={trigger}
            onChange={(input: InputCandidate) => {
              onChange({
                member: input.value,
                hash,
              });
            }}
            showValidationError={showValidationError}
            actions={actions}
            action={action}
            integrations={integrations}
            isMultiple={false}
            description={{
              ...description,
              label: "Assignee",
              icon: "",
              inputId: description?.inputId ?? "",
              subLabel: description?.subLabel ?? "",
              dynamic: description?.dynamic ?? false,
            }}
            hideTeams={true}
            filterTriggerFields={(option) =>
              !triggerFieldsToHide.includes(option.outputId)
            }
            defaultTab={MemberTab.root}
            isNested
          />
        </S.CheckListItemFieldWrapper>
      </S.CheckListItemBottom>
    </S.CheckListItemWrapper>
  );
};
